// Small client-only chat render-key/copy constants, split from the controller to keep transport logic focused.

let localTurnSequence = 0;

export function nextLocalTurnId(): string {
  localTurnSequence += 1;
  return `local-human-${String(localTurnSequence)}`;
}

export const QUEUED_NOTE =
  'Ritona is finishing the previous message — yours is queued and will be answered next.';
export const REFUSED_NOTE = 'Your message is on the record, but Ritona could not act on it.';
export const SEND_TRANSPORT_NOTE =
  'The chat connection failed before Ritona could confirm your message. Check the conversation before trying again.';
